// NOTE
// This is a "special" react component that does not strictly play by
// React's rules.
//
// Conceptually, this component creates a "portal" in React by
// closing its render method off from updates (by simply rendering a div and
// never accepting re-renders) then reconnecting itself to the React lifecycle
// by listening for any new props (using componentWillReceiveProps)

import React, { Component } from 'react';
import { loadModules } from 'esri-loader';
import { createView, createSearch, createLayerList } from '../../utils/esriLoader';
import { isIncidentCertified, formatIdentifierForApi } from '../../utils/incidentHelper';
import LayerManager from './LayerManager';
import DrawToolbar from './DrawToolbar';
import { addUserLayerToMap} from './mapHub';
import { filterOperations } from '../../redux/filter';
import { userOperations } from '../../redux/user';
import { authOperations } from '../../redux/auth';
import { incidentsOperations } from '../../redux/incidentList';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setOriginLayerDefinitionExpression, setVisiblePerimeters, setCustomFilterDefinitionExpression } from './mapHub';

import consts from '../../defaults/Enums.json'
import originFields from '../../defaults/PointOfOriginFields.json';
import printConfig from '../../defaults/Print.json';

import './Map.css'

class Map extends Component 
{
  constructor(props) {

    super(props);
    this.pauseActionButtonRef = React.createRef();

    this.state = {
      drawingPaused: false
    };

  }

  componentDidMount() {
    if (!this.props.mapState.loaded) 
    {
      this.startup(this.props.appConfig.viewOptions);
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    // Tell React to never update this component, that's up to us
    return false;
  }


  toggleInputCase = () => {
    
    if (this.state.drawingPaused) 
      {
        document.getElementById("pauseIncidentDrawButton").classList.remove("esri-icon-play");
        document.getElementById("pauseIncidentDrawButton").classList.add("esri-icon-pause");
        document.getElementById("pauseIncidentDrawButton").title = "Pause Incident Querying";
        document.getElementById("pauseIncidentDrawAlert").classList.add("esri-hidden");
        
        this.props.setMapDrawingPaused(false);
        
        this.setState({
          drawingPaused: false
        });

        if (this.props.filter.isBasicFilterActive) 
          {
            this.props.setFilterLoading(true);
            setOriginLayerDefinitionExpression(this.props.filter).then( response => 
            {
              this.props.setQueriedIncidentsTotal(response.total);
              this.props.setDisplayedIncidentsCount(response.features.length);
              this.props.setIncidents(response.features);
              this.props.setVisibleIncidents(response.features);
              this.props.setFilterLoading(false);
            });
          }
          else 
          {
            this.props.setFilterLoading(true);
            setCustomFilterDefinitionExpression(this.props.user.activeCustomFilter).then( response => 
              {
                this.props.setQueriedIncidentsTotal(response.total);
                this.props.setDisplayedIncidentsCount(response.features.length);
                this.props.setIncidents(response.features);
                this.props.setVisibleIncidents(response.features);
                this.props.setFilterLoading(false);
              });
          }

      } 
      else 
      {
        document.getElementById("pauseIncidentDrawButton").classList.add("esri-icon-play");
        document.getElementById("pauseIncidentDrawButton").classList.remove("esri-icon-pause");
        document.getElementById("pauseIncidentDrawButton").title = "Resume Incident Querying";
        document.getElementById("pauseIncidentDrawAlert").classList.remove("esri-hidden");

        this.props.setMapDrawingPaused(true);

        this.setState({
          drawingPaused: true
        });
      }
  }

  render() {
    return (
      <div ref="mapDiv" id="viewContainer">
        <div id="pauseTopbar">
            <button id="pauseIncidentDrawButton" onClick={this.toggleInputCase} ref={this.pauseActionButtonRef} type="button" className="action-button esri-icon-pause" title="Pause Incident Querying"></button>
        </div>
      </div>
    );
  }

  
  //
  // JSAPI Stuff
  //

  startup = (viewOptions) => {
    const node = 'viewContainer';
    if (this.props.mapState.currentExtent) 
    {
      viewOptions.extent = this.props.mapState.currentExtent
    }

    createView(node, null, this.props.appConfig.use3D, viewOptions).then(
      args => {
        this.init(args);
        createSearch(this.view, 'geosearch', this.props.appConfig.searchWidgetOptions).then(
          search => {
            this.search = search;
            this.layerManager = new LayerManager(this.view, this.props.appConfig, this.search, this.props.isReadOnly);
            this.layerManager.then(() => {

             this.props.auth.userLayers.forEach(userLayer => {
                addUserLayerToMap(userLayer).then(response => {
              }); 
            });
              if (this.props.filter.isBasicFilterActive) 
              {
                this.props.setFilterLoading(true);
                setOriginLayerDefinitionExpression(this.props.filter).then( response => 
                {
                  this.props.setQueriedIncidentsTotal(response.total);
                  this.props.setDisplayedIncidentsCount(response.features.length);
                  this.props.setIncidents(response.features);
                  this.props.setVisibleIncidents(response.features);
                  this.props.setFilterLoading(false);
                });
              }
              else 
              {
                this.props.setFilterLoading(true);
                setCustomFilterDefinitionExpression(this.props.user.activeCustomFilter).then( response => 
                  {
                    this.props.setQueriedIncidentsTotal(response.total);
                    this.props.setDisplayedIncidentsCount(response.features.length);
                    this.props.setIncidents(response.features);
                    this.props.setVisibleIncidents(response.features);
                    this.props.setFilterLoading(false);
                  });
              }
              this.setupEventHandlers(this.view);
              this.finishedLoading();

            },
              error => {
                console.log('Error initializing layer manager');
                this.props.onMapLoadError();
              }
            );
          }
        );

        createLayerList(this.view, this.props.appConfig.supportLayers[this.props.appConfig.env].map(item => { return item.portalItem.id }), this.onAddUserLayer, this.onRemoveUserLayer);
      },
      error => console.error(error)

    );
  }
  onAddUserLayer = () => 
  {
    this.props.onUserLayerAdd();
  }

  onRemoveUserLayer = (event) => 
  {
    this.props.onUserLayerRemove(event.item);
  }

  finishedLoading = () => {
    // Update app state only after map and widgets are loaded
    this.props.onMapLoaded();
  }

  init = (args) => {
    this.map = args.view.map;
    this.view = args.view;
    this.drawToolbar = new DrawToolbar(this.view);
    this.activeWidget = null;
  }

  setupEventHandlers = (view) => {

    loadModules([
      'esri/core/watchUtils',
      'dojo/topic',
      'esri/geometry/support/jsonUtils',
      'esri/rest/print',
      'esri/rest/support/PrintParameters',
      'esri/rest/support/PrintTemplate',
      'esri/widgets/FeatureForm',
      'esri/widgets/DistanceMeasurement2D',
      'esri/widgets/AreaMeasurement2D',
      'esri/form/FormTemplate',
      'esri/form/elements/FieldElement',
      'esri/form/elements/GroupElement'
    ])
      .then((
        [
          watchUtils,
          topic,
          geometryJsonUtils,
          print,
          PrintParameters,
          PrintTemplate,
          FeatureForm,
          DistanceMeasurement2D,
          AreaMeasurement2D,
          FormTemplate,
          FieldElement,
          GroupElement
        ]
      ) => {

        // Add a new feature form with grouped fields
        var activeWidget = null;
        const perimeterFeatureLayer = view.map.allLayers.find(function (layer) 
        {
          return layer.title === consts.layerTitles.perimetersLayer;
        });

        const fireHistoryFeatureLayer = view.map.allLayers.find(function (layer) 
        {
          return layer.title === "Working Perimeters";
        });

        const closeNifsPerimeterButton = document.getElementById("btnCloseUpdateNifsPerimeter");
        const closeFireHistoryPerimeterButton = document.getElementById("btnCloseUpdateFireHistoryPerimeter");

        const nifsFeatureForm = new FeatureForm({
          container: "updateNifsPerimeterForm",
          layer: perimeterFeatureLayer,
          fieldConfig: [
            {
              name: "IncidentName",
              label: "Incident Name",
              editable: true
            },
            {
              name: "IRWINID",
              label: "IRWIN ID",
              editable: true
            }
          ]
        });

        const fireHistoryFeatureForm = new FeatureForm({
          container: "updateFireHistoryPerimeterForm",
          layer: fireHistoryFeatureLayer,
          fieldConfig: [
            {
              name: "IncidentName",
              label: "Incident Name",
              editable: false
            },
            {
              name: "IRWINID",
              label: "IRWIN ID",
              editable: true
            }
          ]
        });

        document.getElementById("distanceButton").addEventListener("click", function () {
          setActiveWidget(null);
          if (!this.classList.contains("active")) {
            setActiveWidget("distance");
          } else {
            setActiveButton(null);
          }
        });

        document.getElementById("areaButton").addEventListener("click", function () {
          setActiveWidget(null);
          if (!this.classList.contains("active")) {
            setActiveWidget("area");
          } else {
            setActiveButton(null);
          }
        });

        document.getElementById("clearButton").addEventListener("click", function () {
          setActiveWidget(null);
          setActiveButton(null);
        });

        function setActiveWidget(type) {
          switch (type) {
            case "distance":
              activeWidget = new DistanceMeasurement2D({
                view: view,
                unit: "imperial"
              });

              activeWidget.viewModel.start();

              view.ui.add(activeWidget, "top-right");
              setActiveButton(document.getElementById("distanceButton"));
              break;

            case "area":
              activeWidget = new AreaMeasurement2D({
                view: view,
                unit: "acres",
                defaultCreateOptions: {
                  mode: 'hybrid'
                }
              });

              activeWidget.viewModel.start();

              view.ui.add(activeWidget, "top-right");
              setActiveButton(document.getElementById("areaButton"));
              break;

            default:
              if (activeWidget) {
                view.ui.remove(activeWidget);
                activeWidget.destroy();
                activeWidget = null;
              }
              break;
          }
        }

        function setActiveButton(selectedButton) {
          // focus the view to activate keyboard shortcuts for sketching
          view.focus();
          var elements = document.getElementsByClassName("active");
          for (var i = 0; i < elements.length; i++) {
            elements[i].classList.remove("active");
          }
          if (selectedButton) 
          {
            selectedButton.classList.add("active");
          }
        }

        // Update attributes of the selected feature.
        document.getElementById("btnUpdateNifsPerimeter").onclick = function () {
            nifsFeatureForm.submit();
        };

         // Update attributes of the selected feature.
         document.getElementById("btnUpdateFireHistoryPerimeter").onclick = function () {
          fireHistoryFeatureForm.submit();
        };

        // Listen to the feature form's submit event.
        // Update feature attributes shown in the form.
        nifsFeatureForm.on("submit", function () {
          if (nifsFeatureForm.feature) {
            // Grab updated attributes from the form.
            const updated = nifsFeatureForm.getValues();

            const irwinID = updated["IRWINID"];
            const objectID = updated["OBJECTID"];

            window.api.updateIrwinIDForNifs(irwinID, objectID).then(response => 
            {

            });
            
            nifsFeatureForm.feature = null;
            document.getElementById("updatePerimeterDiv").classList.add("esri-hidden");
            document.getElementById("updateNifsPerimeterForm").classList.add("esri-hidden");
            //view.ui.remove(nifsFeatureForm);
          }
        });

          fireHistoryFeatureForm.on("submit", function () {
          if (fireHistoryFeatureForm.feature) {
            // Grab updated attributes from the form.
            const updated = fireHistoryFeatureForm.getValues();

            const irwinID = updated["IRWINID"];
            const objectID = updated["OBJECTID"];

            window.api.updateIrwinIDForFireHistory(irwinID, objectID).then(response => 
              {

              });
            
            fireHistoryFeatureForm.feature = null;
            document.getElementById("updatePerimeterDiv").classList.add("esri-hidden");
            document.getElementById("updateFireHistoryPerimeterForm").classList.add("esri-hidden");
            //view.ui.remove(fireHistoryFeatureForm);
          }
        });


        view.popup.on("trigger-action", function (event) {
          if (event.action.id === "popup-add-irwinid-nifs") 
          {
            editNifs();
          }

          if (event.action.id === "popup-add-irwinid-firehistory") 
          {
            editFireHistory();
          }
        });

        function editNifs() {
          // If the EditorViewModel's activeWorkflow is null, make the popup not visible
          view.popup.visible = false;
          // Call the Editor update feature edit workflow
          nifsFeatureForm.feature = view.popup.selectedFeature;
          if (document.getElementById("updatePerimeterDiv").classList.contains("esri-hidden")) 
          {
            document.getElementById("updatePerimeterDiv").classList.remove("esri-hidden");
          }

          if (document.getElementById("updateNifsPerimeterForm") && document.getElementById("updateNifsPerimeterForm").classList.contains("esri-hidden")) 
          {
            document.getElementById("updateNifsPerimeterForm").classList.remove("esri-hidden");
          }

          
          if (document.getElementById("updateFireHistoryPerimeterForm") && !document.getElementById("updateFireHistoryPerimeterForm").classList.contains("esri-hidden")) 
          {
            document.getElementById("updateFireHistoryPerimeterForm").classList.add("esri-hidden");
          }

          view.ui.add(nifsFeatureForm, "top-right");
          view.ui.move("btnUpdatePerimeter", "top-right")
          view.popup.spinnerEnabled = false;

          closeNifsPerimeterButton.addEventListener("click", function (evt) {
            // Prevent the default behavior for the back button and instead remove the editor and reopen the popup
            evt.preventDefault();
            document.getElementById("updatePerimeterDiv").classList.add("esri-hidden");
            document.getElementById("updateNifsPerimeterForm").classList.add("esri-hidden");
          });
        }

        function editFireHistory() {
          // If the EditorViewModel's activeWorkflow is null, make the popup not visible
          view.popup.visible = false;
          // Call the Editor update feature edit workflow

          fireHistoryFeatureForm.feature = view.popup.selectedFeature;
          if (document.getElementById("updatePerimeterDiv").classList.contains("esri-hidden")) 
          {
            document.getElementById("updatePerimeterDiv").classList.remove("esri-hidden");
          }

          if (document.getElementById("updateNifsPerimeterForm") && !document.getElementById("updateNifsPerimeterForm").classList.contains("esri-hidden")) 
          {
            document.getElementById("updateNifsPerimeterForm").classList.add("esri-hidden");
          }

          if (document.getElementById("updateFireHistoryPerimeterForm") && document.getElementById("updateFireHistoryPerimeterForm").classList.contains("esri-hidden")) 
          {
            document.getElementById("updateFireHistoryPerimeterForm").classList.remove("esri-hidden");
          }

          view.ui.add(fireHistoryFeatureForm, "top-right");
          view.ui.move("btnUpdatePerimeter", "top-right")
          view.popup.spinnerEnabled = false;

          closeFireHistoryPerimeterButton.addEventListener("click", function (evt) {
            // Prevent the default behavior for the back button and instead remove the editor and reopen the popup
            evt.preventDefault();
            document.getElementById("updatePerimeterDiv").classList.add("esri-hidden");
            document.getElementById("updateFireHistoryPerimeterForm").classList.add("esri-hidden");
          });
        }

        view.popup.viewModel.on("trigger-action", (event) => {
          let popupIncident = {};

          if (event.action.id === "popup-view-incident") {
            this.props.onIncidentSelection(view.popup.viewModel.selectedFeature.attributes.FORID);
            view.popup.close();
          }

          if (event.action.id === "popup-zoom-to-incident") {
            //TODO: All this perimeter stuff needs to go
            popupIncident = {
              attributes: view.popup.selectedFeature.attributes,
              geometry: (view.popup.selectedFeature.geometry) ? view.popup.selectedFeature.geometry.toJSON() : null
            }

            setVisiblePerimeters({
              id: formatIdentifierForApi(popupIncident.attributes[originFields.forId]),
              useFinalService: isIncidentCertified(popupIncident),
              returnFeatures: true
            }).then(result => {
              //IMH: If no result here from final service, need to swap to NIFS
              if (result.features && result.features.length === 1) {
                let options =
                {
                  target: geometryJsonUtils.fromJSON(result.features[0].geometry)
                }
                view.goTo(options);
                view.popup.close();
              }
              else {
                let options =
                {
                  target: view.popup.selectedFeature.geometry,
                  zoom: 14
                }

                view.goTo(options);
                view.popup.close();
              }
            }
            );
          }
        });

        // extent-change
        watchUtils.whenTrue(view, "stationary", () => {
         
          this.props.updateExtent(view.extent.toJSON());

          if (this.props.filter.isBasicFilterActive) 
              {
                if (this.props.filter.mapDrawingPaused) {
                  return;
                }
                this.props.setFilterLoading(true);
        
                setOriginLayerDefinitionExpression(this.props.filter).then( response => {
                  this.props.setQueriedIncidentsTotal(response.total);
                  this.props.setDisplayedIncidentsCount(response.features.length);
                  this.props.setIncidents(response.features);
                  this.props.setVisibleIncidents(response.features);
                  this.props.setFilterLoading(false);
                });
              }
              else 
              {
                if (this.props.filter.mapDrawingPaused) {
                  return;
                }
                this.props.setFilterLoading(true);
                
                setCustomFilterDefinitionExpression(this.props.user.activeCustomFilter).then( response => {
                  this.props.setQueriedIncidentsTotal(response.total);
                  this.props.setDisplayedIncidentsCount(response.features.length);
                  this.props.setIncidents(response.features);
                  this.props.setVisibleIncidents(response.features);
                  this.props.setFilterLoading(false);
                });
              }
        });

        topic.subscribe('Map/extent-changed', (cb, done, failed) => {
          watchUtils.whenTrue(view, "stationary", () => {
            cb(view.extent);
          });
        });

        topic.subscribe('Map/set-extent', (args, done, failed) => {

          // Set the extent on the view
          let newExtent = args.target.extent.expand(1.3);
          this.view.extent = newExtent.toJSON();
        });

        topic.subscribe('Map/get-extent', (done, failed) => {
          // Get the extent on the view
            done(this.view.extent);
        });

        topic.subscribe('Map/get-current-basemap', (done, failed) => {
          // Get the extent on the view
          done(this.view.map.basemap);
        });

        topic.subscribe('Map/set-map-view-target', (args, done, failed) => {
          let options = {
            target: geometryJsonUtils.fromJSON(args.target)
          }
          if (view.type === '3d') {
            options.tilt = args.tilt;
          }
          if (args.zoom) {
            options.zoom = args.zoom;
          }

          view.goTo(options).then(() => {
            done();
          });
        });

        topic.subscribe('Map/zoom-to-polygon', (poly, done, failed) => {

          view.goTo(poly).then(() => {
            done();
          });
        });

        topic.subscribe('Map/get-map-screenshot', (done, failed) => {
          // Get the extent on the view
          this.view.takeScreenshot().then(screenshot => {
            done(screenshot);
          });
        });

        topic.subscribe('Map/get-screenshot', (name, done, failed) => {

        
          const printUrl = printConfig.printTaskUrl;
          const template = new PrintTemplate({
            format: "png32",
            scalePreserved: false,
            exportOptions: {
              dpi: 384
            },
            layout: "a4-portrait",
            layoutOptions: {
              titleText: name
            }
          });

          let printParameters = new PrintParameters({
            view: view,
            template: template
          });

          print.execute(printUrl, printParameters).then(
            result => {
              done(result);
            },
            error => {
              console.log(error);
              failed(error);
            }
          );
        });



        topic.subscribe('Map/set-view-popup', (args, done, failed) => {
          // view.popupManager.enabled = args.enabled;
          if (!args.enabled && view.popup) {
            //close popup if disabled
            view.popup.visible = false;

          }
          done();
        });


      });
  }
}

const mapStateToProps = state => ({
  filter: state.filter,
  incidentList: state.incidentList,
  user: state.user,
  auth: state.auth
})

const mapDispatchToProps = function (dispatch) {
  return bindActionCreators({
    ...filterOperations,
    ...incidentsOperations,
    ...userOperations,
    ...authOperations
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Map);

